export const Security = ({ color = "currentColor" }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 7.29168C9.30964 7.29168 8.75 7.85133 8.75 8.54168C8.75 9.23204 9.30964 9.79168 10 9.79168C10.6904 9.79168 11.25 9.23204 11.25 8.54168C11.25 7.85133 10.6904 7.29168 10 7.29168ZM10 7.29168V12.2917M16.875 9.92697V5.78461C16.875 5.06723 16.4159 4.43033 15.7354 4.20347L10.527 2.46736C10.1849 2.35333 9.81506 2.35333 9.47295 2.46736L4.26462 4.20347C3.58405 4.43033 3.125 5.06723 3.125 5.78461V9.92697C3.125 14.0707 6.66667 16.0417 10 17.8399C13.3333 16.0417 16.875 14.0707 16.875 9.92697Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Security
